export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9645.7213fc73.jpg";